import React, { type FunctionComponent } from 'react'
import { SelectOptionType } from 'domains/banners/types/banner.types'
import { MerchandisingFormField } from 'domains/merchandising/components/form-field/MerchandisingFormField'
import { MerchandisingFormInput } from 'domains/merchandising/components/form-input/MerchandisingFormInput'
import { MerchandisingFormRow } from 'domains/merchandising/components/form-row/MerchandisingFormRow'
import { MerchandisingFormSection } from 'domains/merchandising/components/form-section/MerchandisingFormSection'
import { MerchandisingFormSelect } from 'domains/merchandising/components/form-input/MerchandisingFormSelect'
import { Schedule } from 'domains/banners/components/banner-form/components'
import { type ControllerProps } from 'utils/react-hook-form/reactHookForm.types'
import { isFlyout } from 'domains/banners/utils/bannerUtils'
import { useSelectOptionsDashMessage } from 'domains/banners/utils/intl.hooks'
import { rankOptions } from 'domains/banners/constants/banner.constants'

interface Props extends Omit<ControllerProps, 'name'> {}

export const BannerFormDetail: FunctionComponent<Props> = ({ form }) => {
  const { watch, errors, register, control, setValue } = form
  const flyout = isFlyout(watch('type'))
  const bannerEnabled: string = watch('bannerEnabled') || 'false'
  const bannerRank: string = watch('bannerRank') || (flyout ? '-80' : '4')
  const localizedRankOptions = useSelectOptionsDashMessage(rankOptions.slice(0, flyout ? 10 : 5))

  return (
    <MerchandisingFormSection
      titleId="bannersDomain.banners.section.detail.title"
      tooltipId="bannersDomain.banners.section.detail.tooltip"
      renderAction
    >
      <MerchandisingFormRow>
        <MerchandisingFormField fullWidth>
          <MerchandisingFormInput
            ref={register({ required: true })}
            control={control}
            identifier="name"
            labelId="bannersDomain.banners.section.details.field.placementName.label"
            errors={errors}
            maxLength={64}
            showLength
          />
        </MerchandisingFormField>
      </MerchandisingFormRow>

      <MerchandisingFormRow>
        <MerchandisingFormField fullWidth>
          <Schedule form={form} />
        </MerchandisingFormField>
      </MerchandisingFormRow>
      <MerchandisingFormRow>
        <MerchandisingFormField>
          <MerchandisingFormSelect
            form={form}
            identifier="bannerRank"
            labelId="bannersDomain.banners.section.details.field.priority.label"
            options={localizedRankOptions}
            defaultValue={bannerRank}
            onChange={({ value }) => setValue('bannerRank', value)}
          />
        </MerchandisingFormField>
        <MerchandisingFormField>
          <MerchandisingFormSelect
            form={form}
            identifier="bannerEnabled"
            labelId="bannersDomain.banners.section.details.field.enabled.label"
            options={[
              { value: 'true', label: 'Enable' },
              { value: 'false', label: 'Disable' },
            ]}
            defaultValue={bannerEnabled}
            onChange={({ value }) => setValue('bannerEnabled', value)}
          />
        </MerchandisingFormField>
      </MerchandisingFormRow>
    </MerchandisingFormSection>
  )
}
